var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtc = function SvgBtc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.997,
    cy: 13.997,
    r: 13.083,
    fill: "#FFA853",
    stroke: "#E6E8EA",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.533,
    d: "m13.64 8.268-.189.663-.934-.224-.933-.225-.184.649-.185.648.62.155.616.159-.934 3.287-.933 3.287-.622-.14-.623-.143-.184.648-.184.649.934.224.933.225-.188.663-.189.664.628.15.627.152.189-.664.188-.664.613.148.613.147-.189.664-.188.663.627.151.627.15.192-.672.19-.67.288-.003c.974-.017 1.861-.561 2.377-1.466.186-.325.349-.9.36-1.266a2.73 2.73 0 0 0-.377-1.485l-.138-.228.13-.097a2.92 2.92 0 0 0 1.192-2.427c-.012-.419-.1-.736-.313-1.137s-.435-.662-.747-.87l-.186-.126.2-.7.2-.705-.628-.15-.627-.151-.189.663-.188.664-.613-.147-.613-.148.189-.663.188-.664-.627-.15-.628-.152zm2.79 2.81c.1.051.23.135.289.189.133.124.317.442.36.628.105.444-.05.993-.378 1.333a1.7 1.7 0 0 1-.69.391c-.305.062-.493.033-1.813-.294l-1.237-.307.355-1.283c.197-.705.369-1.3.383-1.316.038-.057 2.481.537 2.73.66Zm-.662 4.105c.3.217.506.58.534.953.021.276-.103.714-.268.945-.231.32-.632.556-1.004.592-.173.018-.291-.007-1.689-.343l-1.503-.361.356-1.283c.196-.705.369-1.3.383-1.32.021-.027.317.037 1.533.336 1.47.364 1.51.377 1.658.481Z"
  })));
};
export default SvgBtc;